import React from "react";
import PolicyPage from "@/pages/PolicyPage";

export default function CancellationPolicy() {
  return (
    <PolicyPage
      title="Cancellation Policy"
      sections={[
        {
          paragraphs: [
            "Appointments cancelled with less than 24 hours notice may be subject to a cancellation fee.",
          ],
        },
        {
          paragraphs: [
            "Same-day, rush, and priority service requests may require advance payment and may become non-refundable once scheduling, travel, or staffing arrangements have been confirmed.",
          ],
        },
        {
          paragraphs: [
            "T&J Clinical Solutions reserves the right to review all cancellations on a case-by-case basis.",
          ],
        },
        {
          heading: "No-Show Policy",
          paragraphs: [
            "If a client is unavailable at the scheduled appointment time, unreachable, or unable to proceed after confirmation, the appointment may be considered a no-show and may result in a service charge.",
          ],
        },
        {
          heading: "Refund Eligibility",
          paragraphs: ["Refund eligibility may vary depending on:"],
          bullets: [
            "travel completed",
            "staff dispatching",
            "scheduling commitments",
            "custom service arrangements",
            "provider/facility agreements",
          ],
        },
        {
          heading: "Facilities, Providers & Recurring Clients",
          paragraphs: [
            "Facilities, providers, recurring clients, and contract-based services may be subject to separate cancellation terms outlined in their individual agreements.",
          ],
        },
      ]}
      footnote="To request cancellation, rescheduling, or support, please contact T&J Clinical Solutions directly as soon as possible."
    />
  );
}
